import React from 'react';
import Userprofile from '../Userprofile/Userprofile';

function formatDate(date: string) {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  return new Intl.DateTimeFormat('en-US', options)
    .format(new Date(date))
    .replace(',', '');
}

const WatchPartyEndScreen: React.FC<{
  watchPartyDetails: IWatchpartyDetails | undefined;
  totalParticipants: number;
  handleClickOnGoHome: () => void;
}> = ({ watchPartyDetails, totalParticipants, handleClickOnGoHome }) => {
  return (
    <div className="grid grid-cols-2 h-dvh max-md:block">
      <div className="overflow-auto p-16 max-sm:p-4 bg-[#1d0532] h-full">
        <div>
          <img
            src={'/logo.png'}
            alt=""
            className="max-w-64 size-full object-cover block cursor-pointer"
            onClick={() => {
              handleClickOnGoHome();
            }}
          />
          <div className="flex flex-col items-start">
            <h2 className="text-gradient-pink text-6xl inline-block m-0 mb-5">
              Watch Party
            </h2>
            <h6 className="text-gradient-pink text-3xl inline-block m-0 font-normal">
              THIS LIVE WATCH PARTY HAS ENDED
            </h6>
          </div>
          <div className="my-12">
            <h4 className="text-gradient-orange text-[16px] inline-block mb-5">
              Hosted By
            </h4>

            <div className="flex items-center gap-2 mb-4">
              <div className="min-w-[60px]">
                <Userprofile
                  item={{ ...watchPartyDetails!.user, email: '' }}
                  isZindexRequired={true}
                />
              </div>
              <div className="text-primary">
                <h5 className="m-0 text-[18px]">
                  {watchPartyDetails?.user.first_name}{' '}
                  {watchPartyDetails?.user.last_name}
                </h5>
                <h6 className="m-0 text-[16px] mt-1">
                  {watchPartyDetails?.user.country}
                </h6>
              </div>
            </div>
          </div>

          {/* <div style={{ margin: '25px 0' }}>
            <h5
              className="text-gradient-orange"
              style={{
                fontSize: 16,
                display: 'inline-block',
                margin: '0 0 5px 0',
              }}
            >
              Scheduled at
            </h5>
            <h6
              className="text-gradient-blue"
              style={{ margin: 0, fontSize: 15, fontWeight: 400 }}
            >
              Apr 03 2025, 05:31 PM
            </h6>
          </div> */}

          {watchPartyDetails && (
            <>
              <div className="flex items-center gap-4 my-7">
                <h5 className="text-gradient-blue text-[16px] m-0 font-medium">
                  Start Time
                </h5>
                <h5 className="text-gradient-orange text-[16px] m-0 font-medium">
                  {formatDate(watchPartyDetails!.started_at)}
                </h5>
              </div>
              <div className="flex items-center gap-4 my-7">
                <h5 className="text-gradient-blue text-[16px] m-0 font-medium">
                  End Time
                </h5>
                <h5 className="text-gradient-orange text-[16px] m-0 font-medium">
                  {formatDate(
                    watchPartyDetails.ended_at !== null
                      ? watchPartyDetails.ended_at
                      : new Date().toString()
                  )}
                </h5>
              </div>
            </>
          )}

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-5">
              <div className="flex items-center gap-1">
                <img src={'/participant.png'} alt="" className="w-7" />
                <h5 className="text-gradient-blue text-[16px] m-0 font-medium">
                  Total number of participants
                </h5>
              </div>
              <h5 className="text-gradient-orange m-0 text-[16px] inline-block">
                {totalParticipants}
              </h5>
            </div>
          </div>

          {/* <h5
            className="text-gradient-blue"
            style={{ fontSize: 16, margin: 0, fontWeight: 500 }}
          >
            How was your experience with audio and video quality in Feud.
          </h5> */}

          <button
            className="gradient-btn text-black w-full p-4 text-[20px] rounded-xl cursor-pointer mt-12"
            onClick={() => {
              handleClickOnGoHome();
            }}
          >
            GO TO HOME
          </button>
        </div>
      </div>
      <div className="p-0 overflow-hidden h-dvh max-md:hidden">
        <img
          src={'/the-end-screen.png'}
          alt="Cover"
          className="size-full object-cover"
        />
      </div>
    </div>
  );
};

export default WatchPartyEndScreen;
